import {RemoteGetFavoriteDoctors} from "data/usecases";
import {GetFavoriteDoctors} from "domain/usecases";
import {makeAuthorizeHttpClientDecorator} from "main/factories/decorators";
import {makeBFFApiUrl} from "main/factories/http";
import {GuideFlowEndpoints} from "main/factories/usecases/endpoints";

export const makeGetFavoriteDoctors = (): GetFavoriteDoctors =>
  new RemoteGetFavoriteDoctors(
    makeBFFApiUrl(GuideFlowEndpoints.medicalFavoriteDoctors),
    makeAuthorizeHttpClientDecorator(),
  );
